<script lang="ts" setup>
import { useAuthenticationStore } from '@/stores/authentication'
import { HeaderWrapper } from '@haskoning/vue-component-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { INDEX_ROUTES } from '@/router'

const authStore = useAuthenticationStore()
const shipStore = useShipStore()
const router = useRouter()

const { writeLoading: shipLoading } = storeToRefs(shipStore)

const { user } = storeToRefs(authStore)

const loading = computed(() => {
	return shipLoading.value
})

const logout = async () => {
	authStore.logout()
	await router.push({ name: INDEX_ROUTES.HOME.AUTH.name })
}

const goToHomePage = () => {
	router.push({ name: INDEX_ROUTES.SHIP.name })
}
</script>

<template>
	<HeaderWrapper
		v-if="user"
		title="SHIP"
		:user="user"
		:loading="loading"
		@logo-click="goToHomePage"
		@logout="logout()"
	>
	</HeaderWrapper>
</template>
